import { createStore } from 'redux'

const initialState = {
  sidebarShow: 'responsive',
  devMode: JSON.parse(localStorage.getItem('devMode') || 'false'),
  selectedDataSource: JSON.parse(localStorage.getItem('selectedDataSource') || 'null')
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      const newState = {...state, ...rest };
      
      // Persist devMode to localStorage
      if ('devMode' in rest) {
        localStorage.setItem('devMode', JSON.stringify(rest.devMode));
      }
      
      // Persist selectedDataSource to localStorage
      if ('selectedDataSource' in rest) {
        localStorage.setItem('selectedDataSource', JSON.stringify(rest.selectedDataSource));
      }
      
      return newState;
    default:
      return state
  }
}

const store = createStore(changeState)
export default store